export default "__VITE_ASSET__CrR9AiNO__"